import { render, staticRenderFns } from "./PerformanceReport.vue?vue&type=template&id=b9c68500&scoped=true"
import script from "./PerformanceReport.vue?vue&type=script&lang=js"
export * from "./PerformanceReport.vue?vue&type=script&lang=js"
import style0 from "./PerformanceReport.vue?vue&type=style&index=0&id=b9c68500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c68500",
  null
  
)

export default component.exports